import React from "react"
import "./color.css"

const EmptyStar = () => {
	return (
		<div className="empty-star">
			<svg width="484.05" height="488.51" viewBox="0 0 484.05 488.51">
				<defs>
					<pattern
						id="pattern"
						preserveAspectRatio="none"
						width="100%"
						height="100%"
						viewBox="0 0 3229 513"
					></pattern>
				</defs>
				<g id="star_empty" transform="translate(-13.93 -11)">
					<rect
						id="Rectangle_1"
						data-name="Rectangle 1"
						width="484.05"
						height="75.2"
						transform="translate(13.93 424.31)"
						opacity="0.4"
						fill="url(#pattern)"
					/>
					<path
						id="Path_1"
						data-name="Path 1"
						d="M146.53,292.75,37.24,213.63s-21.63-12.81-15.37-32.45c6.54-19.92,31.31-17.07,31.31-17.07H188.36L229.91,35.48S235.32,11,256.1,11,282,35.48,282,35.48l41.55,128.64,135.18-.29s25-2.56,31.31,17.36c6.54,19.64-15.37,32.16-15.37,32.16l-109.29,79.4L407.5,421.39s10,23.05-6.83,35.29c-16.79,12-35.29-4.84-35.29-4.84L256.1,372.44,146.81,452.12s-18.78,16.79-35.57,4.55S105,421.39,105,421.39Z"
						fill="#eccf3e"
					/>
					<path
						id="Path_2"
						data-name="Path 2"
						d="M130.02,431.06,256.1,339.14l126.07,91.64L333.79,282.5l126.36-91.64H304.19L256.1,42.59,208,190.86H52.04L178.12,282.5Z"
						fill="#fff"
						fillRule="evenodd"
					/>
					<path
						id="Path_3"
						data-name="Path 3"
						d="M26.71,179.48c9.68-10.53,26.47-8.54,26.47-8.54H193.49L231.05,54.83c6.54-23.62,12.24-36.43,24.76-36.14,11.38,0,16.79,11.1,24.48,34.15l38.14,118.11,140.3-.29s17.08-1.71,26.75,8.82c-13.66-6-109.86-.57-171.61,0L270.33,40.88c-7.69-24.76-23.62-20.77-29.31,1.71L199.18,179.48C134.86,178.34,33.26,170.94,26.71,179.48Z"
						fill="#f9d167"
					/>
				</g>
			</svg>
		</div>
	)
}

export default EmptyStar
